var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProEquipmentsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.236,
    height: 24.499,
    viewBox: "0 0 27.236 24.499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3671",
    "data-name": "Group 3671",
    transform: "translate(0.249 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3672",
    "data-name": "Group 3672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2274",
    "data-name": "Path 2274",
    d: "M61.279-8327l-10.553-.017a3.11,3.11,0,0,1-2.677-1.551l-5.267-9.141a3.111,3.111,0,0,1,0-3.083l1.126-1.968c1.356-2.375,3.15-5.515,4.1-7.182a3.1,3.1,0,0,1,2.685-1.559H50.7c2.725.006,8.765.017,10.551.019a3.106,3.106,0,0,1,2.677,1.549c.807,1.4,2.218,3.851,3.46,6l1.807,3.138a3.1,3.1,0,0,1,0,3.081c-1.249,2.187-3.972,6.95-5.227,9.148a3.1,3.1,0,0,1-2.689,1.56ZM56.8-8343.889a4.71,4.71,0,0,1,3.9,4.636,4.711,4.711,0,0,1-3.9,4.639v5.99l4.49.009a1.48,1.48,0,0,0,1.285-.746c.664-1.161,1.735-3.035,2.783-4.869.937-1.642,1.855-3.247,2.446-4.28a1.483,1.483,0,0,0,0-1.476c-.9-1.572-2.576-4.477-3.915-6.8l-1.35-2.342a1.48,1.48,0,0,0-1.281-.739c-1.092,0-2.735-.009-4.454-.011Zm-7.388-5.253c-.61,1.069-1.566,2.744-2.532,4.434l-2.7,4.718a1.489,1.489,0,0,0,0,1.476l.882,1.53c1.39,2.412,3.366,5.846,4.385,7.61a1.482,1.482,0,0,0,1.281.739l4.452.011v-5.99a4.714,4.714,0,0,1-3.9-4.639,4.712,4.712,0,0,1,3.9-4.636v-5.99l-4.49-.009A1.489,1.489,0,0,0,49.408-8349.142Zm3.49,9.889a3.1,3.1,0,0,0,3.094,3.094,3.1,3.1,0,0,0,3.089-3.094,3.092,3.092,0,0,0-3.089-3.089A3.094,3.094,0,0,0,52.9-8339.253Z",
    transform: "translate(-42.621 8351.251)",
    fill: "#333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProEquipmentsIcon);
export default __webpack_public_path__ + "static/media/proEquipmentsIcon.2424449682f40957572a941b8fe2ea6c.svg";
export { ForwardRef as ReactComponent };